module.exports = __webpack_public_path__ + "img/brasil.32280029.png";